import { Directive } from "@angular/core";

/**
 * Wrapper for search form content in a mat-card with distinct background styling.
 * Provides visual separation for search forms within cards.
 *
 * @example
 * <mat-card>
 *   <mgd-card-search-form>
 *     <mat-form-field>
 *       <input matInput placeholder="Search...">
 *     </mat-form-field>
 *   </mgd-card-search-form>
 * </mat-card>
 */
@Directive({
    selector: "mgd-card-search-form",
    host: {
        class: "mgd-card-search-form"
    }
})
export class CardSearchFormDirective {}
